module.exports = __webpack_public_path__ + "img/pedin-logo.3eaa7f41.png";